/**
 * Para onde leva uma notificação ao ser clicada, a partir dos dados que ela
 * carrega (campanha interativa, conexão, cota…). null = não há tela específica.
 */
export function notificationLink(data: Record<string, unknown> | null | undefined, alertType?: string | null): string | null {
  const d = data || {};
  const str = (v: unknown) => (typeof v === 'string' && v.trim() ? v.trim() : null);
  const explicit = str(d.link);
  if (explicit && explicit.startsWith('/')) return explicit;
  // Campanha interativa (agendador e disparo); campaignId vem das notificações antigas
  const campaignId = str(d.interactiveCampaignId) ?? str(d.campaignId);
  if (campaignId) return `/campanhas/interativa/${encodeURIComponent(campaignId)}/relatorio`;
  const session = str(d.sessionName);
  if (session) return `/whatsapp?busca=${encodeURIComponent(session)}`;
  if (str(d.sessionId) || alertType === 'SESSION_FAILED') return '/whatsapp';
  if (str(d.quotaType) || alertType?.startsWith('QUOTA')) return '/configuracoes';
  return null;
}
